<template>
  <div>
      <IQOSTable
        :cols="[{
            title: $t('worker_tips_history.col_date'),
            key: 'closed_at',
            date: true
        },
        {
            title: $t('worker_tips_history.col_date'),
            key: 'closed_at',
            time: true
        },
        {
            title: $t('worker_tips_history.col_check'),
            key: 'local_id',
        },
        {
            title: $t('worker_tips_history.col_total'),
            key: 'total',
            currency: 'code'
        },
        {
            title: $t('worker_tips_history.col_pay'),
            key: 'pay_method',
        }]"
        :rows="orders"
        >
            <template #col-pay_method="slotProps">
                {{ slotProps.rowItem.pay_method ? $t(`pay_methods.${slotProps.rowItem.pay_method}`) : '' }}
            </template>
      </IQOSTable>
  </div>
</template>

<script>
import moment from 'moment'

import WaitersAPI from '@/api/waiters'

export default {
    props: {
        waiter: Object
    },
    data() {
        return {
            orders: [],

            range: {
                start: moment().startOf('month').toDate(),
                end: moment().endOf('month').toDate(),
            }
        }
    },
    methods: {
        fetchOrders() {
            const unix_start = moment(this.range.start).valueOf();
            const unix_end = moment(this.range.end).valueOf();

            WaitersAPI.getOrdersHistory(
                this.waiter._id,
                unix_start,
                unix_end
            ).then(data => {
                this.orders = data.orders;
            }).catch(error => {

            });
        }
    },
    computed: {
        currency() {
            return this.$store.state.currency;
        }
    },
    mounted() {
        this.fetchOrders();
    }
}
</script>

<style scoped>
.waiter-orders-table tbody {
    display: inline-table;
}


</style>